<template>
  <div class="egl-dialog-elm">
    <el-dialog
      :title="$locale('accountPayable.payment') + $locale('global.registration')"
      :visible="isShow"
      class="egl-dialog payment-registration-dialog"
      :modal="false"
      :before-close="closeDialog"
      :modal-append-to-body="true"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <el-form label-position="top">
        <div class="module-item base-info">
          <div class="module-item-tit">{{ $locale("accountPayable.accountPayableDetailBasicInformation") }}</div>
          <el-row :gutter="25">
            <el-col :span="4">
              <el-form-item :label="$locale('accountPayable.accountPayableDetail') + '*'">
                <el-input v-model="accountPayableForm.name" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="$locale('accountPayable.th.requestDeadDate') + '*'">
                <el-input v-model="accountPayableForm.requestDeadDateText" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="$locale('accountPayable.th.paymentDueDate')">
                <el-input v-model="accountPayableForm.paymentDueDateText" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$locale('accountPayable.th.recordAmount') + '/' + $locale('accountPayable.invoiceAmount') + '*'">
                <el-input v-model="accountPayableForm.needPayAmount" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="module-item">
          <div class="module-item-tit">{{ $locale("accountPayable.paymentDetailBasicInformation") }}</div>

          <el-row :gutter="25">
            <el-col :span="5">
              <el-form-item :label="$locale('accountPayable.paymentName') + '*'">
                <el-input v-model="basicInfo.name" readOnly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentDate')}*`">
                <CommDatePicker
                  v-model="basicInfo.date"
                  :value.sync="basicInfo.date"
                  width="100%"
                  :showWeekly="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="`${$locale('accountPayable.paymentCategory')}1*`">
                <el-select v-model="basicInfo.typeText" >
                  <el-option :value="basicInfo.typeText" :label="basicInfo.typeText"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="`${$locale('accountPayable.paymentCategory')}2*`">
                <el-select v-model="basicInfo.typeDetailText">
                  <el-option :value="basicInfo.typeDetailText" :label="basicInfo.typeDetailText"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentTotal')}*`">
                <el-input v-model="paymentTotal" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="13" v-if="basicInfo.type == 'OFFSET'">
              <el-form-item>
                <el-select v-model="basicInfo.payOffset.offsetDetail">
                  <el-option :value="basicInfo.payOffset.offsetDetail" :label="basicInfo.payOffset.offsetDetail"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-table
            :data="tableData"
            class="egl-table"
            stripe
            :cell-class-name="setCellClassName"
            v-if="accountPayableForm.type != 'ELSE_BUY'"
          >
            <el-table-column :label="$locale('global.cinemaName')" prop="cinemaName"></el-table-column>
            <el-table-column :label="$locale('accountPayable.customerName')" prop="clientName"></el-table-column>

            <el-table-column :label="$locale('global.titleOfWork')" prop="filmName" v-if="accountPayableForm.type == 'TICKETING'"></el-table-column>
            <el-table-column :label="$locale('accountPayable.productName')" prop="storeName" v-else-if="accountPayableForm.type == 'BUY' || accountPayableForm.type == 'PROXY_BUY'"></el-table-column>

            <el-table-column :label="$locale('accountPayable.targetPeriod')" prop="dateInterval" min-width="90"></el-table-column>

            <el-table-column :label="$locale('accountPayable.income')" prop="incomeTotal" v-if="accountPayableForm.type == 'TICKETING'" align="right"></el-table-column>
            <el-table-column :label="$locale('accountPayable.mobilization')" prop="actualNumberTotal" v-if="accountPayableForm.type == 'TICKETING'" align="right"></el-table-column>
            
            <el-table-column :label="$locale('accountPayable.th.recordAmount')">
              <template slot-scope="scope">{{ scope.row.needPayAmount.toLocaleString() }}</template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.th.amountPaid')" align="right">
              <template slot-scope="scope">{{ scope.row.payAmount.toLocaleString() }}</template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.payMoney')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.payMoney.toLocaleString() }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.adjustment')" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.adjustment"
                  v-if="scope.$index != tableData.length - 1"
                  @input="inputAdjustment('tableData', scope.$index)"
                  @blur="blurAdjustment('tableData', scope.$index)"
                ></el-input>
                <span v-else>{{ scope.row.adjustment }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.otherOffset')" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.offset.payAmount"
                  v-if="scope.$index != tableData.length - 1"
                  readOnly
                  class="disable-input"
                  @focus="openOffsetDialog(scope.row, 'tableData', scope.$index)"
                >
                </el-input>
                <span v-else>{{ scope.row.offset.payAmount.toLocaleString() }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.th.accountPayableBalance')" align="right">
              <template slot-scope="scope">{{ scope.row.actualAmountResidual.toLocaleString() }}</template>
            </el-table-column>
          </el-table>

          <div class="other-table-box" v-if="otherTableData.length > 0">
            <div class="other-table-tit" v-if="accountPayableForm.type != 'ELSE_BUY'">{{ $locale("accountPayable.otherPurchaseDetail") }}</div>
            <el-table :data="otherTableData" class="egl-table" stripe :cell-class-name="setOtherTableCellClassName">
              <el-table-column :label="$locale('global.cinemaName')" prop="cinemaName"></el-table-column>
              <el-table-column :label="$locale('accountPayable.customerName')" prop="clientName"></el-table-column>
              <el-table-column :label="$locale('global.name')" prop="showName"></el-table-column>
              
              <el-table-column :label="$locale('accountPayable.targetPeriod')" prop="dateInterval" v-if="tableData.length > 0"></el-table-column>
              <el-table-column :label="$locale('accountPayable.th.requestDeadDate')" prop="requestDeadDateText" v-else></el-table-column>

              <el-table-column :label="$locale('accountPayable.th.recordAmount')">
                <template slot-scope="scope">{{ scope.row.needPayAmount.toLocaleString() }}</template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.th.amountPaid')">
                <template slot-scope="scope">{{ scope.row.payAmount.toLocaleString() }}</template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.payMoney')">
                <template slot-scope="scope">
                  <span>{{ scope.row.payMoney.toLocaleString() }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.adjustment')">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.adjustment"
                    v-if="scope.$index != otherTableData.length - 1"
                    @input="inputAdjustment('otherTableData', scope.$index)"
                    @blur="blurAdjustment('otherTableData', scope.$index)"
                  >
                  </el-input>
                  <span v-else>{{ scope.row.adjustment.toLocaleString() }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.otherOffset')" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.offset.payAmount"
                    v-if="scope.$index != otherTableData.length - 1"
                    readOnly
                    class="disable-input"
                    @focus="openOffsetDialog(scope.row, 'otherTableData', scope.$index)"
                  >
                  </el-input>
                  <span v-else>{{ scope.row.offset.payAmount.toLocaleString() }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.th.accountPayableBalance')" align="right">
                <template slot-scope="scope">{{ scope.row.actualAmountResidual.toLocaleString() }}</template>
              </el-table-column>
            </el-table>
          </div>

          <div class="table-total">
            <div class="clearfix">
              <span>{{ $locale("accountPayable.payMoneyTotal") }}</span>
              <span>{{ payMoneyTotal.toLocaleString() }}</span>
            </div>
            <div class="clearfix">
              <span>{{ $locale("accountPayable.paymentAmountDifference") }}</span>
              <span>-</span>
            </div>
            <div class="clearfix">
              <span>{{ $locale("accountPayable.threeTotal") }}</span>
              <span>{{ threeTotal.toLocaleString() }}</span>
            </div>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
        <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.save") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import { mapState, mapActions } from "vuex";
import { getClientListService } from "@/helpers/service/api/common";

export default {
  name: "AccountPayablePaymentDetail",
  data() {
    return {
      accountPayableForm: {},
      basicInfo: {},
      initDate: 0,
      paymentTotal: "-",
      tableData: [],
      otherTableData: [],
      payMoneyTotal: 0,
      threeTotal: 0,
      originalData: {
        list: [],
        threeTotal: 0,
        tableData: {},
        otherTableData: {},
      },
      itemIndex: "",
      offsetTag: {
        tableName: "",
        index: -1,
      },
    };
  },
  computed: {
    ...mapState("api", {
      cinemaList: state => state.cinemaList,
      clientList: state => state.clientList,
    }),
  },
  methods: {
    ...mapActions("accountPayable", [ "setOffsetHistory" ]),
    closeDialog() {
      this.$emit("closeFn");
    },
    save_fn() {
      let payDetails = [];
      let actualAmountResidual = 0;
      let adjustment = 0;
      let offset = 0;
      let payMoney = 0;
      
      if (this.tableData.length > 0) {
        payDetails = [ ...this.tableData ];
        payDetails.length -= 1;

        actualAmountResidual += this.tableData[this.tableData.length - 1].actualAmountResidual;
        adjustment += this.tableData[this.tableData.length - 1].adjustment;
        offset += this.tableData[this.tableData.length - 1].offset.payAmount;
        payMoney += this.tableData[this.tableData.length - 1].payMoney;
      }

      if (this.otherTableData.length > 0) {
        payDetails = [ ...payDetails, ...this.otherTableData ];
        payDetails.length -= 1;

        actualAmountResidual += this.otherTableData[this.otherTableData.length - 1].actualAmountResidual;
        adjustment += this.otherTableData[this.otherTableData.length - 1].adjustment;
        offset += this.otherTableData[this.otherTableData.length - 1].offset.payAmount;
        payMoney += this.otherTableData[this.otherTableData.length - 1].payMoney;
      }

      this.$emit("setPaymentDetails", payDetails, {
        index: this.itemIndex,
        actualAmountResidual,
        adjustment,
        offset,
        payMoney,
      });
    },
    initDailog(accountPayableForm, basicInfo, payDetails) {
      let tableData = [];
      let otherTableData = [];
      let tableData_last_tr = {
        dateInterval: this.$locale("accountPayable.trTotal"),
        requestDeadDateText: this.$locale("accountPayable.trTotal"),
        incomeTotal: 0,
        actualNumberTotal: 0,
        needPayAmount: 0,
        payAmount: 0,
        payMoney: 0,
        adjustment: 0,
        offset: {
          payAmount: 0,
        },
        actualAmountResidual: 0,
      };
      let otherTableData_last_tr = {
        dateInterval: this.$locale("accountPayable.trTotal"),
        requestDeadDateText: this.$locale("accountPayable.trTotal"),
        needPayAmount: 0,
        payAmount: 0,
        payMoney: 0,
        adjustment: 0,
        offset: {
          payAmount: 0,
        },
        actualAmountResidual: 0,
      };
      let payMoneyTotal = 0;
      let threeTotal = 0;
      let originalData = {
        list: [],
        threeTotal: 0,
        tableData: {
          adjustment: 0,
          offset: {
            payAmount: 0,
          },
          actualAmountResidual: 0,
          payMoney: 0,
        },
        otherTableData: {
          adjustment: 0,
          offset: {
            payAmount: 0,
          },
          actualAmountResidual: 0,
          payMoney: 0,
        },
      };

      let cinemaOption = [];
      let clientOption = [];

      this.cinemaList.map(item => {
        cinemaOption.push(item.id, item.name);
      });

      this.clientList.map(item => {
        clientOption.push(item.id, item.name);
      });

      payDetails.map(item => {
        let tr = {
          ...item,
          // adjustment: 0,
          // actualAmountResidual: 0,

          cinemaName: cinemaOption[cinemaOption.indexOf(item.cinemaId) + 1],
          clientName: clientOption[clientOption.indexOf(item.clientId) + 1],

          requestDeadDateText: "",
        };

        if (item.sourceType == "elseBuy") {
          tr.requestDeadDateText = tr.requestDeadDate != "" ? this.$moment(tr.requestDeadDate).format("YYYY-MM-DD") : "",

          otherTableData.push(tr);
          otherTableData_last_tr.adjustment += item.adjustment;
          otherTableData_last_tr.actualAmountResidual += item.actualAmountResidual;
          otherTableData_last_tr.needPayAmount += item.needPayAmount;
          otherTableData_last_tr.payAmount += item.payAmount;
          otherTableData_last_tr.payMoney += item.payMoney;
          otherTableData_last_tr.offset.payAmount += item.offset.payAmount;
        } else {
          // if (item.sourceType == "ticketing") {
          //   tr.incomeTotal += item.incomeTotal;
          //   tr.actualNumberTotal += item.actualNumberTotal;
          // }

          tableData.push(tr);
          tableData_last_tr.adjustment += item.adjustment;
          tableData_last_tr.actualAmountResidual += item.actualAmountResidual;
          tableData_last_tr.needPayAmount += item.needPayAmount;
          tableData_last_tr.payAmount += item.payAmount;
          tableData_last_tr.payMoney += item.payMoney;
          tableData_last_tr.offset.payAmount += item.offset.payAmount;
        }

        payMoneyTotal += item.payMoney;
        threeTotal = threeTotal + item.payMoney + item.adjustment + item.offset.payAmount;
      });

      if (tableData.length > 0) {
        tableData.push(tableData_last_tr);
        originalData.tableData = {
          adjustment: tableData_last_tr.adjustment,
          offset: {
            payAmount: tableData_last_tr.offset.payAmount,
          },
          actualAmountResidual: tableData_last_tr.actualAmountResidual,
          payMoney: tableData_last_tr.payMoney,
        };
      }

      if (otherTableData.length > 0) {
        otherTableData.push(otherTableData_last_tr);
        originalData.otherTableData = {
          adjustment: otherTableData_last_tr.adjustment,
          offset: {
            payAmount: otherTableData_last_tr.offset.payAmount,
          },
          actualAmountResidual: otherTableData_last_tr.actualAmountResidual,
          payMoney: otherTableData_last_tr.payMoney,
        };
      }

      originalData.list = payDetails;
      originalData.threeTotal = threeTotal;

      this.accountPayableForm = { ...accountPayableForm };
      this.basicInfo = { ...basicInfo };
      this.initDate = basicInfo.date;
      this.tableData = tableData;
      this.otherTableData = otherTableData;
      this.payMoneyTotal = payMoneyTotal;
      this.threeTotal = threeTotal;
      this.originalData = originalData;
      this.itemIndex = accountPayableForm.itemIndex;
    },

    setCellClassName({ rowIndex, columnIndex }) {
      let dataLength = this.tableData.length;

      if (rowIndex < dataLength - 1) {
        if (columnIndex >= 4) {
          return "ta-r";
        }
      }
    },
    setOtherTableCellClassName({ rowIndex, columnIndex }) {
      let dataLength = this.otherTableData.length;

      if (rowIndex < dataLength - 1) {
        if (columnIndex >= 4) {
          return "ta-r";
        }
      }
    },
    openOffsetDialog(row, tableName, index) {
      const trOffset = JSON.parse(JSON.stringify(this[tableName][index].offset));
      let obj = {
        actualAmountResidual: row.actualAmountResidual,
        cinemaName: row.cinemaName,
        clientName: row.clientName,
        filmName: row.filmName,
        time: row.dateInterval,
      };

      let enteredMsg = {
        invoice: [],
        revenue: [],
        other: [],
        payAmount: 0,
        ...trOffset,
      };

      this.setOffsetHistory(enteredMsg);
      this.offsetTag = { tableName, index };
      this.$emit("openOffsetDialog", obj);
    },
    inputAdjustment(tableName, index) {
      let num = this[tableName][index].adjustment;
      let dataIndex = index;
      let difference = 0;
      let { needPayAmount, payAmount, payMoney, adjustment, offset } = this[tableName][index];
      let payMoneyTotal = 0;

      num = parseInt(num.toString().replace(/[^\d-]/g, "")) || 0;

      if (tableName != "tableData" && this.tableData.length > 0) {
        dataIndex += this.tableData.length - 1;
      }
      
      difference = num - this.originalData.list[dataIndex].adjustment;

      this[tableName][index].payMoney = needPayAmount - payAmount - num - offset.payAmount;

      this[tableName][this[tableName].length - 1].adjustment = this.originalData[tableName].adjustment + difference;
      this[tableName][this[tableName].length - 1].payMoney = this.originalData[tableName].payMoney - difference;

      if (this.tableData.length > 0) {
        payMoneyTotal += this.tableData[this.tableData.length - 1].payMoney;
      }

      if (this.otherTableData.length > 0) {
        payMoneyTotal += this.otherTableData[this.otherTableData.length - 1].payMoney;
      }

      this.threeTotal = this.originalData.threeTotal + difference;
      this.payMoneyTotal = payMoneyTotal;
    },
    blurAdjustment(tableName, index) {
      let num = this[tableName][index].adjustment;
      let dataIndex = index;
      let difference = 0;

      if (tableName != "tableData" && this.tableData.length > 0) {
        dataIndex += this.tableData.length - 1;
      }

      num = parseInt(num.toString().replace(/[^\d-]/g, "")) || 0;
      difference = num - this.originalData.list[dataIndex].adjustment;

      this[tableName][index].adjustment = num;
      this.originalData.list[dataIndex].adjustment = num;
      this.originalData[tableName].adjustment = this.originalData[tableName].adjustment + difference;
      this.originalData[tableName].payMoney = this.originalData[tableName].payMoney - difference;
      this.originalData.threeTotal = this.originalData.threeTotal + difference;
    },
    setOffset(obj) {
      const { tableName, index } = this.offsetTag;
      const { needPayAmount, payAmount, payMoney, adjustment, offset } = this[tableName][index];
      let diff_offset = obj.payAmount - offset.payAmount;
      let dataIndex = index;

      if (tableName != "tableData" && this.tableData.length > 0) {
        dataIndex += this.tableData.length - 1;
      }

      this[tableName][index].offset = { ...obj };
      this[tableName][index].payMoney -= diff_offset;

      this[tableName][this[tableName].length - 1].offset.payAmount += diff_offset;
      this[tableName][this[tableName].length - 1].payMoney -= diff_offset;

      this.originalData.list[dataIndex].offset = { ...obj };
      this.originalData[tableName].payMoney -= diff_offset;
      this.originalData.threeTotal += diff_offset;
      this.threeTotal = this.originalData.threeTotal;
    },
  },
  mounted() {},
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CommDatePicker,
  },
  watch: {
    "basicInfo.date"() {
      this.basicInfo.date = this.initDate;
    },
    isShow(newVal) {
      if(newVal) {
        // mapping client name
        const ids = this.otherTableData.map(item => item.clientId);
        if (ids.length > 0) {
          getClientListService({
            ids,
            page: 0,
            pageSize: 9999,
            field: ["id", "name"]
          }).then(res => {
            const clientList = res.data.data;
            this.otherTableData.forEach(item => {
              item.clientName = clientList.find(item => item.id).name;
            });
          });
        }
      }
    }
  },
};
</script>
